import { createResource, For, Suspense } from "solid-js";
import { A } from "@solidjs/router";
import { listBucket, S3Object } from "~/utils";

import "~/_assets/genie-collections.css";

const getCollections = async (): Promise<S3Object[]> => {
	"use server";

	const collections = await listBucket( "genie-tools/collections/" );

	// Ensure `Contents` is typed as an array and default to an empty array if it's undefined
	return collections ?? [];
};

export default function Collections() {
	const [collections] = createResource( getCollections );

	return (

		
			<div class="container px-4 sm:px-6 lg:px-8 bg-white rounded-lg">
				<h1>Genie Collections</h1>

				<ul role="list" class="divide-y divide-gray-100">

					<Suspense fallback={<p>Loading Collections</p>}>
						<For each={collections()}>
							{collection => (
								<li class="relative flex justify-between gap-x-6 py-5">
									<CollectionItem key={collection.Key.replaceAll( 'genie-tools/collections/', '' )} lastModified={collection.LastModified} />
								</li>
							)}
						</For>
					</Suspense>
				</ul>
			</div>
		
	)
}

const CollectionItem = props => {
	return (
		<>
			<div class="flex min-w-0 gap-x-4">
				<div class="min-w-0 flex-auto">
					<p class="text-sm/6 font-semibold text-gray-900">
						<A href={`/collections/${props.key}`}>
							<span class="absolute inset-x-0 -top-px bottom-0"></span>
							{JSON.stringify( props.key )}
						</A>
					</p>
					<p class="mt-1 flex text-xs/5 text-gray-500">
						<A href={`/collections/${props.key}`} class="relative truncate hover:underline">{props.key}</A>
					</p>
				</div>
			</div>
			<div class="flex shrink-0 items-center gap-x-4">
				<div class="hidden sm:flex sm:flex-col sm:items-end">
					<p class="text-sm/6 text-gray-900">Co-Founder / CEO</p>
					<p class="mt-1 text-xs/5 text-gray-500">Last modified <time datetime="2023-01-23T13:23Z">3h ago</time></p>
				</div>
				<svg class="size-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
					<path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
				</svg>
			</div>
		</>
	)
}